<template>
  <div>
    <figure class="highcharts-figure">
      <highcharts ref="chart" :options="options" />
      <p class="highcharts-description highcharts-linked-description">
        <strong>Figure : </strong> {{ $t('compGraphicsHeatingPie.help') }}
      </p>
    </figure>
    <br v-if="!onlyGraphics" />
    <b-table
      v-if="!onlyGraphics"
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="series"
    >
      <b-table-column
        :label="$t('compGraphicsHeatingPie.label-1')"
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>
      <b-table-column
        :label="$t('emissions.t.co2e.short')"
        numeric
        v-slot="props"
      >
        {{ Math.round(props.row.y) | splitNumberTons }} &plusmn;
        {{ Math.round(props.row.uncertainty) | splitNumberTons }}
      </b-table-column>
      <b-table-column
        :label="$t('compGraphicsHeatingPie.label-2')"
        numeric
        v-slot="props"
      >
        {{ Math.round((props.row.y / intensity) * 100) }} %
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'HeatingPie',
  props: {
    ghgi: {
      type: Object,
      default: null
    },
    onlyGraphics: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    series: function () {
      let series = []
      for (let building of this.ghgi.buildings) {
        for (let heating of building.heatings) {
          let oindex = series.findIndex(
            (obj) => obj.name === this.$t(heating.type)
          )
          let cheatingIntensity = building.getHeatingCarbonIntensity(
            heating,
            this.ghgi.year
          )
          if (oindex < 0) {
            series.push({
              name: this.$t(heating.type),
              y: cheatingIntensity.intensity,
              uncertainty: cheatingIntensity.uncertainty
            })
          } else {
            series[oindex].y += cheatingIntensity.intensity
            series[oindex].uncertainty += cheatingIntensity.uncertainty
          }
        }
      }
      return series
    },
    intensity: function () {
      return this.ghgi.emissions.buildings.heatings.intensity.intensity
    },
    options: function () {
      const self = this
      return {
        chart: {
          type: 'pie'
        },
        title: {
          verticalAlign: 'middle',
          floating: true,
          text: `<b>${self.$options.filters.splitNumberTons(
            Math.round(self.intensity)
          )} ${self.$t('t.co2e')} </b>`
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: this.enabledLabels,
              formatter () {
                return `<b>${
                  this.point.name
                }:</b> ${self.$options.filters.splitNumberTons(
                  this.y
                )} ${self.$t('t.co2e')}`
              }
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: this.$t('carbon.footprint'),
            colorByPoint: true,
            data: this.series
          }
        ],
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return `${this.key}<br/><b>${self.$options.filters.splitNumberTons(
              this.y
            )} ${self.$t('t.co2e')}</b> (${
              Math.round(this.percentage * 10) / 10
            }%)`
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
